// Author Lin
// Date 2021-10-25 14:58:14

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingFurnaceLiningTemperatureModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingFurnaceLiningTemperature(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
